import _regeneratorRuntime from "/opt/eazyads-player/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _slicedToArray from "/opt/eazyads-player/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _typeof from "/opt/eazyads-player/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _asyncToGenerator from "/opt/eazyads-player/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.immediate.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.string.search.js";
import { Device } from '@capacitor/device';
import { Capacitor } from '@capacitor/core';
var platform = Capacitor.getPlatform();
var getUuid = require('uuid-by-string');
var uuid_regex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
export function getDevid() {
  return _getDevid.apply(this, arguments);
}
function _getDevid() {
  _getDevid = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var urlParams, info, uuid;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // -- Dev: Multiple screens in iframes on same window (required to create teaser video)
          urlParams = new URLSearchParams(window.location.search);
          if (!((process.env.NODE_ENV == 'development' || process.env.NODE_ENV == 'staging') && urlParams.get('id'))) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return", urlParams.get('id'));
        case 3:
          _context.next = 5;
          return Device.getId();
        case 5:
          info = _context.sent;
          uuid = info.uuid || info.identifier;
          return _context.abrupt("return", uuid.match(uuid_regex) ? uuid : getUuid(uuid, 3));
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getDevid.apply(this, arguments);
}
export function radians_to_degrees(radians) {
  var pi = Math.PI;
  return radians * (180 / pi);
}
export function sleep(t) {
  return new Promise(function (resolve) {
    setTimeout(function () {
      resolve();
    }, t);
  });
}
export function keepAlive() {
  // Workaround to prevent blocking event loop
  // => https://nodejs.org/en/docs/guides/event-loop-timers-and-nexttick/
  return new Promise(function (resolve) {
    setImmediate(function () {
      resolve();
    });
  });
}

// ---
var timeoutTable = {};
export function clearExecuteAt(id) {
  if (timeoutTable.hasOwnProperty(id)) {
    // Cancel old timer with this id first
    clearTimeout(timeoutTable[id]);
    delete timeoutTable[id];
  }
}
export function executeAt(id, callback, timestamp) {
  for (var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }
  if (timestamp instanceof Object && timestamp.valueOf) timestamp = timestamp.valueOf();
  var delay = timestamp - Date.now();
  clearExecuteAt(id);
  var timeoutID;
  var MAX_INT32 = 0x7FFFFFFF; // setTimeout limit is MAX_INT32=(2^31-1) => https://stackoverflow.com/a/18182660
  if (delay > MAX_INT32) timeoutID = setTimeout(function () {
    executeAt.apply(void 0, [id, callback, timestamp].concat(args));
  }, MAX_INT32);else timeoutID = setTimeout.apply(void 0, [function () {
    callback.apply(void 0, arguments);
    delete timeoutTable[id];
  }, delay].concat(args));
  timeoutTable[id] = timeoutID;
  return timeoutID;
}
// ---

/**
 * Shuffles an array with the Fisher-Yates algorithm
 * https://dev.to/codebubb/how-to-shuffle-an-array-in-javascript-2ikj#:~:text=The%20first%20and%20simplest%20way,)%20%3D%3E%200.5%20%2D%20Math.
 * 
 * @param {*} array 
 */
export function shuffleArray(array) {
  for (var i = array.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
}
export function guessContentType(filename) {
  var l_file = filename.toLowerCase();
  if (l_file.match(/(\.|\/)(mp4|mov|quicktime)$/i)) return 'video/mp4';
  if (l_file.match(/(\.|\/)(gif)$/i)) return 'image/gif';
  if (l_file.match(/(\.|\/)(png)$/i)) return 'image/png';
  if (l_file.match(/(\.|\/)(jpe?g)$/i)) return 'image/jpg';
  if (l_file.match(/(\.|\/)(pdf)$/i)) return 'application/pdf';
}
export function getLocalFileURL(url) {
  var protocol = platform == 'ios' ? 'capacitor' : 'http'; // ERR_UNKNOWN_URL_SCHEME

  if (url.startsWith("content://")) {
    url = url.replace('content:/', protocol + '://localhost/_capacitor_content_');
  } else {
    if (url.startsWith("file://")) url = url.replace('file://', protocol + '://localhost/_capacitor_file_');else if (url.startsWith('/') && !url.includes("://")) url = protocol + '://localhost/_capacitor_file_' + url;
  }
  return url;
}
export function object_equals(x, y) {
  // Problem with JSON.stringify(x) == JSON.stringify(y)
  // => order of the properties is important.
  //    Getting issue on iPad as it reports album changed although nothing has changed
  // https://stackoverflow.com/a/6713782/5331765

  if (x === y) return true;
  // if both x and y are null or undefined and exactly the same

  if (!(x instanceof Object) || !(y instanceof Object)) return false;
  // if they are not strictly equal, they both need to be Objects

  if (x.constructor !== y.constructor) return false;
  // they must have the exact same prototype chain, the closest we can do is
  // test there constructor.

  for (var p in x) {
    if (!x.hasOwnProperty(p)) continue;
    // other properties were tested using x.constructor === y.constructor

    if (!y.hasOwnProperty(p)) return false;
    // allows to compare x[ p ] and y[ p ] when set to undefined

    if (x[p] === y[p]) continue;
    // if they have the same strict value or identity then they are equal

    if (_typeof(x[p]) !== "object") return false;
    // Numbers, Strings, Functions, Booleans must be strictly equal

    if (!object_equals(x[p], y[p])) return false;
    // Objects and Arrays must be tested recursively
  }

  for (p in y) if (y.hasOwnProperty(p) && !x.hasOwnProperty(p)) return false;
  // allows x[ p ] to be set to undefined

  return true;
}
export function mergeObject(src, dst) {
  Object.entries(src).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    if (dst[key] === undefined) {
      dst[key] = value;
    } else if (_typeof(value) === 'object') {
      mergeObject(src[key], dst[key]);
    }
  });
}